import {BaseSearchableService} from "./Core/BaseSearchableService";

class RiverService extends BaseSearchableService {
    get Url() { return super.Url + "/rivers"; }
    get ModelName() { return "River"; }
    get PrimaryKeyProperty() { return "riverId"; }
    get TitleProperty() { return "name"; }
    get SubtitleProperty() { return "gnisId"; }

    Get() {
        return this.SendRequest(BaseSearchableService.GET, this.request);
    }

    GetSubtitle(model) {
        return model ? "GNIS ID: " + model.gnisId : "";
    }
}

export const service = new RiverService();

